/* ============================================================
   Koleksiyon kartı hızlı "Sepete ekle"
   - Tek istekte ürünü ekler + sepet çekmecesi ve ikon bölümlerini çeker
   - Çekmeceyi güncel içerikle doldurup açar (sayfa yenilemeye gerek yok)
   - "Eklendi ✓" geri bildirimini anında gösterir
   ============================================================ */
(function () {
  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  // Sepet ikonundaki SADECE sayacı güncelle (ikon SVG'sini koru; ikon değişmesin/küçülmesin)
  function setCount(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.t720-icon__count') || link.querySelector('.cart-count-bubble');
    if (count && count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 't720-icon__count';
        link.appendChild(bubble);
      }
      var inner = bubble.querySelector('span[aria-hidden]');
      var txt = count < 100 ? String(count) : '99+';
      if (inner) inner.textContent = txt; else bubble.textContent = txt;
    } else if (bubble) {
      bubble.remove();
    }
  }
  // cart-icon-bubble bölümünün HTML'inden ürün sayısını çıkar
  function countFromSection(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('.cart-count-bubble span[aria-hidden]') || doc.querySelector('.cart-count-bubble span');
    if (el) {
      var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
      if (!isNaN(n)) return n;
    }
    return null;
  }

  // Sepet çekmecesi içeriğini enjekte et + dolu/boş durumunu senkronla
  function injectDrawer(html) {
    if (!html) return false;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
    var live = document.querySelector('#CartDrawer');
    if (!fresh || !live) return false;
    live.innerHTML = fresh.innerHTML;
    var cd = cartDrawer();
    var inner = live.querySelector('.drawer__inner');
    var isEmpty = inner ? inner.classList.contains('is-empty') : false;
    if (cd) cd.classList.toggle('is-empty', isEmpty);
    return true;
  }

  // Çekmece verisi gelmezse sepet API'sinden taze çek (yedek) — çekmeceyi AÇMADAN,
  // sadece içeriğini günceller ki sepete tıklayınca ürünler görünsün.
  function fetchDrawerFallback() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: {}, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (state) {
        if (!state || !state.sections) return;
        var c = countFromSection(state.sections['cart-icon-bubble']);
        if (c === null && typeof state.item_count === 'number') c = state.item_count;
        setCount(c);
        injectDrawer(state.sections['cart-drawer']);
      })
      .catch(function () {});
  }

  function feedback(btn) {
    var span = btn.querySelector('span:not(.sold-out-message)') || btn;
    if (btn.getAttribute('data-orig-text') === null || btn.getAttribute('data-orig-text') === undefined) {
      btn.setAttribute('data-orig-text', span.textContent.trim());
    }
    span.textContent = 'Eklendi ✓';
    btn.classList.add('is-added');
    clearTimeout(btn._addTmr);
    btn._addTmr = setTimeout(function () {
      span.textContent = btn.getAttribute('data-orig-text');
      btn.classList.remove('is-added');
    }, 1800);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var qa = form.closest('.card-wrapper .quick-add');
      if (!qa) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;

      // Dawn'ın modal/submit handler'ını engelle, kendi hızlı eklememizi yap
      e.preventDefault();
      e.stopPropagation();

      var btn = form.querySelector('[name="add"]');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }

      // Sepet bölümlerini tek istekte iste (ekstra /cart.js isteği yok -> daha hızlı)
      var data = new FormData(form);
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      data.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) { throw res; } // stok yok vb.

          // Buton geri bildirimi hemen
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            feedback(btn);
          }

          // Sadece sayacı güncelle (ikon değişmesin) + çekmece içeriğini güncelle (AÇMADAN).
          var sections = res.sections || {};
          var c = countFromSection(sections['cart-icon-bubble']);
          setCount(c);
          if (!injectDrawer(sections['cart-drawer'])) {
            fetchDrawerFallback();
          }

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
          }
        });
    },
    true // capture
  );
})();
